"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "versionReducer", {
  enumerable: true,
  get: function get() {
    return _versionReducer["default"];
  }
});
Object.defineProperty(exports, "pageReducer", {
  enumerable: true,
  get: function get() {
    return _pageReducer["default"];
  }
});
Object.defineProperty(exports, "userReducer", {
  enumerable: true,
  get: function get() {
    return _userReducer["default"];
  }
});
Object.defineProperty(exports, "loginReducer", {
  enumerable: true,
  get: function get() {
    return _loginReducer["default"];
  }
});
exports.trackEventResetData = exports.trackEvent = exports.trackPage = exports.updateDataLayer = exports.replaceRootReducers = exports.addReducer = exports.removeReducer = void 0;

var _versionReducer = _interopRequireDefault(require("./reducers/versionReducer"));

var _pageReducer = _interopRequireDefault(require("./reducers/pageReducer"));

var _userReducer = _interopRequireDefault(require("./reducers/userReducer"));

var _loginReducer = _interopRequireDefault(require("./reducers/loginReducer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

window.a3m_datalayer = {};
var currentReducers = [_versionReducer["default"], _pageReducer["default"], _userReducer["default"], _loginReducer["default"]];

var onError = function onError(reducerId, error) {
  try {
    var errorCallback = window.a3m_datalayer.onError;

    if (errorCallback) {
      errorCallback(reducerId, error);
    }
  } catch (e) {
    console.error(e);
  }
};

var removeReducer = function removeReducer(id) {
  if (id) {
    currentReducers = currentReducers.filter(function (reducer) {
      return reducer.id !== id;
    });
  }
};

exports.removeReducer = removeReducer;

var addReducer = function addReducer(reducer, id) {
  removeReducer(id); // eslint-disable-next-line no-param-reassign

  reducer.id = id;
  currentReducers.push(reducer);
};

exports.addReducer = addReducer;

var replaceRootReducers = function replaceRootReducers() {
  for (var _len = arguments.length, reducers = new Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  currentReducers = reducers;
};

exports.replaceRootReducers = replaceRootReducers;

var updateDataLayer = function updateDataLayer() {
  var trackData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Promise.all(currentReducers.map(function (reducer) {
    try {
      return Promise.resolve(reducer())["catch"](function (error) {
        // Error reducer asíncrono
        onError(reducer.id, error);
        return {};
      });
    } catch (error) {
      // Error reducer síncrono
      onError(reducer.id, error);
      return {};
    }
  })).then(function (results) {
    return [].concat(_toConsumableArray(results), [trackData]).reduce(function (total, result) {
      return Object.assign(total, result);
    }, window.a3m_datalayer);
  });
};

exports.updateDataLayer = updateDataLayer;

var trackPage = function trackPage(trackData) {
  return updateDataLayer(trackData).then(function () {
    return _satellite.track('testPV');
  });
};

exports.trackPage = trackPage;

var trackEvent = function trackEvent(trackData) {
  return updateDataLayer(trackData).then(function () {
    return _satellite.track('sendEvent');
  });
};

exports.trackEvent = trackEvent;

var resetData = function resetData(trackData) {
  updateDataLayer(Object.keys(trackData).reduce(function (total, key) {
    return _objectSpread({}, total, _defineProperty({}, key, undefined));
  }, {}));
};

var trackEventResetData = function trackEventResetData(trackData) {
  return trackEvent(trackData).then(function () {
    return resetData(trackData);
  });
};

exports.trackEventResetData = trackEventResetData;
window.a3m_datalayer_fn = {
  addReducer: addReducer,
  removeReducer: removeReducer,
  replaceRootReducers: replaceRootReducers,
  updateDataLayer: updateDataLayer,
  trackPage: trackPage,
  trackEvent: trackEvent,
  trackEventResetData: trackEventResetData
};